import sanitizeAttributeValue from '../../../xml/sanitizeAttributeValue.js'

export default function generatePageMargins(tag, { orientation }) {
	// Margins are required when setting custom orientation,
	// otherwise they'd be `0`.
	// https://gitlab.com/catamphetamine/write-excel-file/-/issues/7#note_782347297
	if (orientation) {
		// Page margins (when printing).
		// https://github.com/randym/axlsx/blob/master/lib/axlsx/workbook/worksheet/page_margins.rb

		const marginLeft = 0.7 // The left margin in inches.
		const marginRight = 0.7 // The right margin in inches.
		const marginTop = 0.75 // The top margin in inches.
		const marginBottom = 0.75 // The bottom margin in inches.
		const header = 0.3 // The header margin in inches.
		const footer = 0.3 // The footer margin in inches.

		return tag('pageMargins', {
			left: marginLeft,
			right: marginRight,
			top: marginTop,
			bottom: marginBottom,
			header,
			footer
		})
	}

	return ''
}